import styled from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "Overlaystyle__Container",
  componentId: "sc-jyqs7h-0"
})(["", " background:rgba(255,255,255,0.75);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);"], {
  "position": "fixed",
  "left": "0px",
  "top": "0px",
  "zIndex": "40",
  "height": "100%",
  "width": "100%"
});